import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FlexBetween from "./FlexBetween";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
  Avatar,
  Button,
  Stack,
} from "@mui/material";
import {
  SettingsOutlined,
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  CreateOutlined,
  ModelTrainingOutlined,
  GroupOutlined,
  SummarizeOutlined,
  LogoutOutlined,
  AnalyticsOutlined,
} from "@mui/icons-material";

import { useDispatch, useSelector } from "react-redux";
import { currentUser, logout } from "state/auth";
import { SIDEBAR_MENU_ITEMS } from "data";

import logo from "../assets/logo.webp";

function stringToColor(string) {
  let hash = 0;
  let i;
  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */
  return color;
}

const Sidebar = ({
  drawerWidth,
  isSidebarOpen,
  setIsSidebarOpen,
  isNonMobile,
}) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();

  const { email, balance, id, authenticated } = useSelector(
    (state) => state.authentication.user
  );

  useEffect(() => {
    setActive(pathname.substring(1));
  }, [pathname]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <Box component="nav">
      {isSidebarOpen && (
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,

            "& .MuiDrawer-paper": {
              color: theme.palette.secondary,
              backgroundColor: theme.palette.background.alt,
              boxSizing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "column" }}
            spacing={{ xs: 0.5, sm: 2, md: 3 }}
            useFlexGap
            sx={{
              height: "100%",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box width="100%">
              <Box m="1.5rem 2rem 2rem 1.5rem">
                <FlexBetween color={theme.palette.secondary.main}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap="0.5rem"
                  >
                    <img
                      src={logo}
                      alt="GLEEM AI"
                      width="200"
                      height="auto"
                    ></img>
                  </Box>
                  {!isNonMobile && (
                    <IconButton
                      onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    >
                      <ChevronLeft />
                    </IconButton>
                  )}
                </FlexBetween>
              </Box>
              <List>
                {SIDEBAR_MENU_ITEMS.map(({ name, icon }) => {
                  return (
                    <ListItem key={name} disablePadding>
                      <ListItemButton
                        onClick={() => {
                          navigate(`/${name}`);
                          setActive(name);
                        }}
                        sx={{
                          backgroundColor:
                            active === name
                              ? theme.palette.yellows[400]
                              : "transparent",
                          color:
                            active === name
                              ? theme.palette.primary[100]
                              : theme.palette.secondary[100],
                          "&:hover": {
                            backgroundColor:
                              active === name
                                ? theme.palette.yellows[700]
                                : theme.palette.background.main,
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            ml: "2rem",
                            color:
                              active === name
                                ? theme.palette.primary[700]
                                : theme.palette.secondary[100],
                          }}
                        >
                          {icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={name}
                          sx={{
                            color:
                              active === name
                                ? theme.palette.primary[700]
                                : theme.palette.secondary[100],
                          }}
                        />
                        {active === name && (
                          <ChevronRightOutlined
                            sx={{
                              ml: "auto",
                              color:
                                active === name
                                  ? theme.palette.primary[700]
                                  : theme.palette.secondary[200],
                            }}
                          />
                        )}
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            </Box>
            <Box bottom="1rem" sx={{ marginBottom: "20px" }}>
              <Divider variant="middle" />
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 0.5, sm: 2, md: 3 }}
                useFlexGap
                sx={{
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "scale(1.03)",
                    cursor: "pointer",
                  },
                }}
              >
                {/* <Avatar src={`https://i.pravatar.cc/70?u=${email}`} /> */}
                <Typography>{email}</Typography>
              </Stack>
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                paddingTop="20px"
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ alignSelf: "center", width: "200px" }}
                  onClick={handleLogout}
                  startIcon={<LogoutOutlined sx={{ fontSize: "25px" }} />}
                >
                  LOG OUT
                </Button>
              </Box>
            </Box>
          </Stack>
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
